export default function Hero() {
  return (
    <section id="hero" className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dynamic%20esports%20competition%20visual%20with%20flowing%20golden%20and%20warm%20orange%20energy%20ribbons%20on%20dark%20background%20modern%20artistic%20style%20professional%20gaming%20atmosphere%20no%20text%20no%20logos&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="51大赛 - 赛事攻略与资源平台"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs md:text-sm font-medium rounded-full bg-white/15 text-white backdrop-blur-sm border border-white/20 mb-5">
              赛事攻略 · 视频资源
            </span>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-extrabold text-white leading-tight mb-4">
              51大赛
              <span className="block mt-1 md:mt-2 text-white/90 text-xl md:text-2xl lg:text-3xl font-semibold">
                你的赛事攻略与资源中心
              </span>
            </h1>

            <p className="text-white/70 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0 mb-3">
              汇集最全的51大赛精彩内容，一站式获取视频回放、资源合集与深度攻略。
              每日更新最新赛事内容，助你不错过每一个高光时刻。
            </p>
            <p className="text-white/55 text-sm leading-relaxed max-w-xl mx-auto lg:mx-0 mb-7">
              当前赛季决赛阶段视频合集已全面上线，高清下载通道全面开放。
            </p>

            <div className="flex items-center justify-center lg:justify-start gap-6 md:gap-8 mb-7">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-white">128.5万</div>
                <div className="text-xs md:text-sm text-white/55 mt-1">视频播放量</div>
              </div>
              <div className="w-px h-10 bg-white/15"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-white">89+</div>
                <div className="text-xs md:text-sm text-white/55 mt-1">选手集锦</div>
              </div>
              <div className="w-px h-10 bg-white/15"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-white">每日更新</div>
                <div className="text-xs md:text-sm text-white/55 mt-1">内容保障</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#media"
                className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
              >
                浏览精彩视频
              </a>
              <a
                href="#index"
                className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold bg-white/10 text-white border border-white/25 rounded-full hover:bg-white/20 transition-all duration-200 whitespace-nowrap cursor-pointer text-center backdrop-blur-sm"
              >
                查看专题合集
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20esports%20arena%20with%20warm%20dramatic%20stage%20lighting%20giant%20LED%20screens%20displaying%20competition%20highlights%20professional%20production%20atmosphere%20golden%20and%20amber%20tones%20epic%20scale&width=700&height=500&seq=hero-main-2026&orientation=landscape"
                alt="51大赛赛事现场精彩瞬间"
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-white/10 pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 hidden md:block">
        <a
          href="#faq"
          className="flex flex-col items-center gap-2 text-white/50 hover:text-white/80 transition-colors cursor-pointer"
        >
          <span className="text-xs">向下探索</span>
          <i className="ri-arrow-down-s-line text-lg animate-bounce"></i>
        </a>
      </div>
    </section>
  );
}